import React, { useState } from 'react';
import HeroSection from '../Hero'; 
import ManageNews from './ManageNews';
import EditForm from './EditForm';
import "../Dashboard.css"


const HeroManager = () => {
  const [editingNews, setEditingNews] = useState(null);

  return (
    <div>
      {editingNews ? (
        <EditForm news={editingNews} onCancel={() => setEditingNews(null)} />
      ) : (
        <>
          <HeroSection />
          <ManageNews onEdit={(news) => setEditingNews(news)} />
        </>
      )}
    </div>
  );
};
export default HeroManager;